import {useEffect, useRef} from 'react';

export function useBarcodeScanner(onScan = () => null, timeout = 30) {
	const bufferRef = useRef('');
	const scanningRef = useRef(false);
	const lastTimeRef = useRef(Date.now());

	useEffect(() => {
		const handler = e => {
			const now = Date.now();
			const diff = now - lastTimeRef.current;

			// Detect if this key is part of a scanner sequence
			if (diff < timeout) {
				scanningRef.current = true;
			} else {
				scanningRef.current = false;
				bufferRef.current = ''; // reset for human typing
			}

			// If scanning, block characters from appearing
			if (scanningRef.current && e.key.length === 1) {
				e.preventDefault();
				bufferRef.current += e.key;
			}

			// Check for end-of-scan (Enter key)
			if (scanningRef.current && e.key === 'Enter') {
				e.preventDefault();
				const barcode = bufferRef.current;
				bufferRef.current = '';

				if (barcode.length > 3) {
					onScan(barcode);
				}

				scanningRef.current = false;
			}

			lastTimeRef.current = now;
		};

		window.addEventListener('keydown', handler);
		return () => window.removeEventListener('keydown', handler);
	}, [onScan, timeout]);
}